export default function ArticleService() {
    return {
        articles: [
            {
                title: "20 nye baner",
                published: { day: "8", month: "September" },
                image: { url: "http://placehold.it/720x360" },
                paragraf:
                    "Lorem ipsum dolor sit amet, consectetur adip isicing elit, sed do eiusmod tempor incidi dunt ut labore et dolore magna aliqua. isicing elit, jkwebk.wv sed do eiusmod tempor incidi dunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adip isicing elit, sed do eiusmod tempor incidi dunt lorem ipsum ut labore et dolore magna aliqua.gna aliqua.",
                url: "#",
                moreTxt: "Læs mere",
                link: "#",
                display: "right",
            },
            {
                title: "UDENDØRS BOLD",
                published: { day: "14", month: "OKTOBER" },
                paragraf:
                    "sed do eiusmod tempor incidi dunt ut labore et dolore magna aliqua. isicing elit, jkwebk.wv sed do eiusmod tempor incidi dunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adip isicing elit, sed do eiusmod tempor incidi dunt lorem ipsum ut labore et dolore magna aliqua.gna aliqua.",
                image: { url: "http://placehold.it/720x360" },
                url: "#",
                moreTxt: "Læs mere",
                link: "#",
                display: "left",
            },
            {
                title: "VANDETS UGE",
                published: { day: "19", month: "OKTOBER" },
                paragraf:
                    "Lorem ipsum dolor sit amet, consectetur adip isicing elit, sed do eiusmod tempor incidi dunt ut labore et dolore magna aliqua. isicing elit, jkwebk.wv sed do eiusmod tempor incidi dunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adip isicing elit, sed do eiusmod tempor incidi dunt lorem ipsum ut labore et dolore magna aliqua.gna aliqua.",
                image: { url: "http://placehold.it/720x360" },
                url: "#",
                moreTxt: "Læs mere",
                link: "#",
                display: "right",
            },
        ],
    };
}
